<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },

    text: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    // Convert false to null to make sure disabled is not rendered instead of disabled="false"
    disableButton() {
      return this.disabled ? true : null;
    },

    getText() {
      return this.text || this.t('pay.js.marketing.checkout_button');
    }
  }
};
</script>
<template>
  <button
    class="c-button"
    type="submit"
    :disabled="disableButton"
  >
    {{ getText }}
  </button>
</template>
